import { useState, useEffect } from "react";
import api from "../api";

const ORANGE = "#EE6A1A";
const VERDE = "#1D9E75";
const ZAP = "#25D366";
const VERM = "#e2445c";

const fmtQuando = (d) => {
  if (!d) return "—";
  const x = new Date(d);
  const dois = (n) => String(n).padStart(2, "0");
  return dois(x.getDate()) + "/" + dois(x.getMonth() + 1) + " às " + dois(x.getHours()) + ":" + dois(x.getMinutes());
};

const COMO = [
  ["Wix", "Automações → Nova automação → gatilho “Formulário enviado” → ação “Enviar requisição HTTP”. Método POST e cole o endereço acima."],
  ["WordPress e Elementor", "No formulário, em Ações após o envio, escolha Webhook e cole o endereço."],
  ["Meta Lead Ads (Instagram e Facebook)", "Ligue pelo Zapier, Make ou n8n: gatilho “Novo lead” e ação de enviar requisição para o endereço."],
  ["Typeform, RD Station, Google Forms", "Todos aceitam webhook nas integrações. Mesmo endereço, método POST."],
];

const card = { background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 14, padding: 22, marginBottom: 18 };
const inp = { width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: 9, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, fontFamily: "'Inter',sans-serif", outline: "none" };
const mono = { ...inp, fontFamily: "ui-monospace, monospace", fontSize: 12.5 };
const lbl = { fontSize: 11, fontWeight: 600, color: "var(--text-secondary)", marginBottom: 5, display: "block", textTransform: "uppercase", letterSpacing: ".04em" };

const btn = (primario, cor) => ({
  padding: "10px 18px", borderRadius: 9, border: primario ? 0 : "1px solid var(--border-color)",
  background: primario ? (cor || ORANGE) : "transparent", color: primario ? "#fff" : "var(--text-secondary)",
  fontWeight: 700, fontSize: 13, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap",
});

const titulo = (t, sub) => (
  <div style={{ marginBottom: 16 }}>
    <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "var(--text-primary)" }}>{t}</h3>
    <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)" }}>{sub}</p>
  </div>
);

function CampoCopiavel({ valor, rotulo }) {
  const [copiado, setCopiado] = useState(false);
  const copiar = () => {
    try { navigator.clipboard.writeText(valor); setCopiado(true); setTimeout(() => setCopiado(false), 2000); }
    catch (e) { window.prompt("Copie:", valor); }
  };
  return (
    <div style={{ marginBottom: 12 }}>
      {rotulo && <label style={lbl}>{rotulo}</label>}
      <div style={{ display: "flex", gap: 8 }}>
        <input readOnly value={valor} onFocus={(e) => e.target.select()} style={mono} />
        <button onClick={copiar} style={btn(true)}>{copiado ? "Copiado!" : "Copiar"}</button>
      </div>
    </div>
  );
}

// ─────────────────────────────── leads do site

function LeadsDoSite() {
  const [chave, setChave] = useState("");
  const [ultimas, setUltimas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");

  const carregar = () => {
    setCarregando(true);
    api.get("/integracoes")
      .then(({ data }) => { setChave(data.chave || ""); setUltimas(data.ultimas || []); setErro(""); })
      .catch((e) => setErro((e.response && e.response.data && e.response.data.message) || "Não foi possível carregar."))
      .finally(() => setCarregando(false));
  };
  useEffect(carregar, []);

  const url = chave ? window.location.origin + "/api/hooks/" + chave : "";

  const gerar = async (trocando) => {
    if (trocando && !window.confirm("Gerar um endereço novo? O endereço atual para de funcionar na hora.")) return;
    try { const { data } = await api.post("/integracoes/chave"); setChave(data.chave); setUltimas([]); }
    catch (e) { window.alert("Não foi possível gerar."); }
  };

  if (erro) return <div style={{ ...card, fontSize: 13, color: VERM }}>{erro}</div>;

  return (
    <>
      <div style={card}>
        {titulo("Contatos do site", "Cole este endereço no formulário do seu site. Cada contato enviado vira um card no funil, com origem Site.")}
        {carregando && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Carregando…</div>}

        {!carregando && !chave && (
          <div>
            <p style={{ fontSize: 14, color: "var(--text-secondary)", marginTop: 0 }}>Você ainda não tem um endereço. Gere o seu para começar.</p>
            <button onClick={() => gerar(false)} style={btn(true)}>Gerar endereço</button>
          </div>
        )}

        {!carregando && chave && (
          <div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
              <input readOnly value={url} onFocus={(e) => e.target.select()} style={{ ...mono, flex: "1 1 340px" }} />
              <button onClick={() => { try { navigator.clipboard.writeText(url); } catch (e) { window.prompt("Copie:", url); } }} style={btn(true)}>Copiar</button>
              <button onClick={() => gerar(true)} style={btn(false)}>Gerar outro</button>
            </div>
            <p style={{ fontSize: 12.5, color: "var(--text-muted)", margin: "12px 0 0", lineHeight: 1.5 }}>
              Trate este endereço como senha: quem tiver ele consegue criar contatos na sua conta.
            </p>
          </div>
        )}
      </div>

      {chave && (
        <div style={card}>
          {titulo("Como ligar no seu site", "O envio tem que ser do tipo POST. Os campos são reconhecidos pelo nome — nome, e-mail, telefone, mensagem e procedimento.")}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {COMO.map(([onde, passo]) => (
              <div key={onde} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)", minWidth: 200 }}>{onde}</div>
                <div style={{ fontSize: 13, color: "var(--text-secondary)", flex: 1, lineHeight: 1.5 }}>{passo}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {chave && (
        <div style={card}>
          {titulo("Últimas chamadas recebidas", "Serve para conferir se o site está mandando certo. Guarda as 20 últimas.")}
          {!ultimas.length && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Nada recebido ainda.</div>}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {ultimas.map((u, i) => (
              <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start", padding: "10px 12px", borderRadius: 9, background: "var(--hover-bg)" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: u.ok ? VERDE : VERM, background: (u.ok ? VERDE : VERM) + "18", borderRadius: 6, padding: "3px 8px", whiteSpace: "nowrap" }}>{u.ok ? "OK" : "erro"}</span>
                <span style={{ fontSize: 12.5, color: "var(--text-secondary)", whiteSpace: "nowrap" }}>{fmtQuando(u.em)}</span>
                <span style={{ fontSize: 12.5, color: "var(--text-primary)", flex: 1, minWidth: 0 }}>{u.resumo}</span>
              </div>
            ))}
          </div>
          {ultimas.length > 0 && <button onClick={carregar} style={{ ...btn(false), marginTop: 14 }}>Atualizar</button>}
        </div>
      )}
    </>
  );
}

// ─────────────────────────────── whatsapp oficial

const PASSOS = [
  ["1. Conta na Meta", "Crie uma conta no Meta Business e faça a verificação da empresa (CNPJ). É o cadastro que libera o envio."],
  ["2. Número dedicado", "Cadastre um número que NÃO esteja em uso no WhatsApp comum. Depois de virar número oficial, ele não volta atrás."],
  ["3. Modelos de mensagem", "Crie dois modelos na categoria Utilidade, com botões de resposta rápida, e espere a aprovação (costuma sair em minutos)."],
  ["4. Credenciais", "Copie o ID do número e um token permanente e cole aqui embaixo."],
  ["5. Webhook", "No app da Meta, em WhatsApp → Configuração, cole o endereço e a chave de verificação desta tela e assine o evento “messages”."],
];

function WhatsappOficial() {
  const [d, setD] = useState(null);
  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [token, setToken] = useState("");
  const [segredo, setSegredo] = useState("");
  const [tel, setTel] = useState("");
  const [testando, setTestando] = useState(false);
  const [semPermissao, setSemPermissao] = useState(false);

  const carregar = () => {
    api.get("/whatsapp")
      .then(({ data }) => { setD(data); setErro(""); })
      .catch((e) => {
        if (e.response && e.response.status === 403) setSemPermissao(true);
        else setErro((e.response && e.response.data && e.response.data.message) || "Não foi possível carregar.");
      });
  };
  useEffect(carregar, []);

  const set = (k, v) => setD((x) => ({ ...x, [k]: v }));

  const salvar = async (extra) => {
    setSalvando(true);
    try {
      const corpo = { ...d, ...(extra || {}) };
      if (token.trim()) corpo.token = token.trim();
      if (segredo.trim()) corpo.appSecret = segredo.trim();
      delete corpo.tokenMascarado;
      const { data } = await api.put("/whatsapp", corpo);
      setD(data); setToken(""); setSegredo(""); setErro("");
    } catch (e) {
      setErro((e.response && e.response.data && e.response.data.message) || "Não foi possível salvar.");
    } finally { setSalvando(false); }
  };

  const testar = async () => {
    if (!tel.trim()) return window.alert("Informe um número para receber o teste.");
    setTestando(true);
    try {
      await api.post("/whatsapp/teste", { telefone: tel });
      window.alert("Enviado! Confira o WhatsApp desse número.");
      carregar();
    } catch (e) {
      window.alert("A Meta recusou: " + ((e.response && e.response.data && e.response.data.message) || "erro desconhecido"));
      carregar();
    } finally { setTestando(false); }
  };

  const novaChave = async () => {
    if (!window.confirm("Gerar nova chave de verificação? Você vai precisar atualizar no painel da Meta.")) return;
    try { const { data } = await api.post("/whatsapp/verify-token"); setD(data); }
    catch (e) { window.alert("Não foi possível gerar."); }
  };

  if (semPermissao) return null;
  if (!d) return <div style={{ ...card, fontSize: 13, color: "var(--text-muted)" }}>Carregando WhatsApp…</div>;

  const pronto = d.temToken && d.phoneNumberId;

  return (
    <>
      <div style={card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
          <div>
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "var(--text-primary)" }}>WhatsApp oficial</h3>
            <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)", maxWidth: 560, lineHeight: 1.5 }}>
              Com isso ligado, a confirmação sai sozinha do número da clínica e a paciente responde tocando num botão — sem abrir link e sem ninguém apertar enviar.
            </p>
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: d.ativo ? VERDE : "var(--text-muted)", background: (d.ativo ? VERDE : "#98A2B3") + "18", borderRadius: 7, padding: "6px 12px", whiteSpace: "nowrap" }}>
            {d.ativo ? "Ligado" : "Desligado"}
          </span>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div>
            <label style={lbl}>ID do número (phone number ID)</label>
            <input value={d.phoneNumberId} onChange={(e) => set("phoneNumberId", e.target.value)} placeholder="Ex: 123456789012345" style={mono} />
          </div>
          <div>
            <label style={lbl}>ID da conta (WABA ID) — opcional</label>
            <input value={d.wabaId} onChange={(e) => set("wabaId", e.target.value)} placeholder="Ex: 987654321098765" style={mono} />
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Token permanente</label>
          <input type="password" value={token} onChange={(e) => setToken(e.target.value)}
            placeholder={d.temToken ? "Salvo: " + d.tokenMascarado + " — preencha só para trocar" : "Cole o token do app da Meta"} style={mono} />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Segredo do app (app secret)</label>
          <input type="password" value={segredo} onChange={(e) => setSegredo(e.target.value)}
            placeholder={d.temAppSecret ? "Salvo — preencha só para trocar" : "Cole o App Secret do app da Meta"} style={mono} />
          <div style={{ fontSize: 11.5, color: d.temAppSecret ? VERDE : "#b45309", marginTop: 6, lineHeight: 1.5 }}>
            {d.temAppSecret
              ? "As chamadas que chegam são conferidas: só passa o que vem assinado pela Meta."
              : "Sem isso, qualquer um que descobrir o endereço do webhook consegue forjar uma resposta. Fica em Configurações do app → Básico → Chave Secreta do Aplicativo."}
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 120px", gap: 12, marginBottom: 14 }}>
          <div>
            <label style={lbl}>Modelo da confirmação</label>
            <input value={d.templateConfirmacao} onChange={(e) => set("templateConfirmacao", e.target.value)} style={mono} />
          </div>
          <div>
            <label style={lbl}>Modelo do aviso de vaga</label>
            <input value={d.templateVaga} onChange={(e) => set("templateVaga", e.target.value)} style={mono} />
          </div>
          <div>
            <label style={lbl}>Idioma</label>
            <input value={d.idioma} onChange={(e) => set("idioma", e.target.value)} style={mono} />
          </div>
        </div>

        <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "var(--text-primary)", cursor: "pointer" }}>
            <input type="checkbox" checked={d.avisarAutomatico} onChange={(e) => set("avisarAutomatico", e.target.checked)} />
            Avisar a lista de espera sozinho quando abrir vaga
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "var(--text-secondary)" }}>
            Chamar até
            <input type="number" min="1" max="30" value={d.quantosAvisar} onChange={(e) => set("quantosAvisar", e.target.value)} style={{ ...inp, width: 70, padding: "7px 9px" }} />
            pessoas por vaga
          </label>
        </div>

        {erro && <div style={{ fontSize: 13, color: VERM, marginBottom: 12 }}>{erro}</div>}

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
          <button onClick={() => salvar()} disabled={salvando} style={btn(true)}>{salvando ? "Salvando…" : "Salvar"}</button>
          <button onClick={() => salvar({ ativo: !d.ativo })} disabled={salvando || (!pronto && !d.ativo)} style={btn(true, d.ativo ? VERM : VERDE)}>
            {d.ativo ? "Desligar envio automático" : "Ligar envio automático"}
          </button>
          {!pronto && <span style={{ fontSize: 12.5, color: "var(--text-muted)" }}>Preencha o ID do número e o token para poder ligar.</span>}
        </div>
      </div>

      <div style={card}>
        {titulo("Endereço do webhook", "É por aqui que a resposta da paciente chega. Cole os dois no painel da Meta, em WhatsApp → Configuração, e assine o evento “messages”.")}
        <CampoCopiavel valor={d.urlWebhook} rotulo="URL de callback" />
        <CampoCopiavel valor={d.verifyToken} rotulo="Chave de verificação (verify token)" />
        <button onClick={novaChave} style={btn(false)}>Gerar nova chave</button>
      </div>

      <div style={card}>
        {titulo("Testar a ligação", "Manda o modelo de confirmação para um número seu. Se a Meta recusar, o motivo aparece na hora.")}
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <input value={tel} onChange={(e) => setTel(e.target.value)} placeholder="(00) 00000-0000" style={{ ...inp, flex: "1 1 220px" }} />
          <button onClick={testar} disabled={testando || !pronto} style={btn(true, ZAP)}>{testando ? "Enviando…" : "Enviar teste"}</button>
        </div>
      </div>

      <div style={card}>
        {titulo("O que precisa estar pronto na Meta", "Esse cadastro é feito uma vez, pela clínica. Depois é só colar as credenciais aqui.")}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {PASSOS.map(([onde, passo]) => (
            <div key={onde} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)", minWidth: 168 }}>{onde}</div>
              <div style={{ fontSize: 13, color: "var(--text-secondary)", flex: 1, lineHeight: 1.5 }}>{passo}</div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 16, padding: 14, borderRadius: 10, background: "var(--hover-bg)", fontSize: 12.5, color: "var(--text-secondary)", lineHeight: 1.6 }}>
          <b style={{ color: "var(--text-primary)" }}>Os modelos precisam ter estes campos, nesta ordem.</b><br />
          <b>Confirmação</b> — 5 campos no corpo: nome, clínica, data, hora, procedimento. Dois botões de resposta rápida:
          o primeiro para confirmar, o segundo para liberar o horário.<br />
          <b>Aviso de vaga</b> — 4 campos no corpo: nome, data, hora, procedimento. Um botão de resposta rápida para pegar a vaga.<br />
          Os textos dos botões você escolhe; o que importa é a ordem.
        </div>
      </div>

      {d.ultimos && d.ultimos.length > 0 && (
        <div style={card}>
          {titulo("Últimos envios e respostas", "Guarda os 20 últimos. Serve para ver se a Meta aceitou e se as respostas estão chegando.")}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {d.ultimos.map((u, i) => (
              <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start", padding: "10px 12px", borderRadius: 9, background: "var(--hover-bg)" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: u.ok ? VERDE : VERM, background: (u.ok ? VERDE : VERM) + "18", borderRadius: 6, padding: "3px 8px", whiteSpace: "nowrap" }}>{u.tipo}</span>
                <span style={{ fontSize: 12.5, color: "var(--text-secondary)", whiteSpace: "nowrap" }}>{fmtQuando(u.em)}</span>
                <span style={{ fontSize: 12.5, color: "var(--text-primary)", flex: 1, minWidth: 0 }}>{u.resumo}</span>
              </div>
            ))}
          </div>
          <button onClick={carregar} style={{ ...btn(false), marginTop: 14 }}>Atualizar</button>
        </div>
      )}
    </>
  );
}

// ─────────────────────────────── tela

export default function Integracoes() {
  const [aba, setAba] = useState("whatsapp");
  const abaBtn = (id, rot) => (
    <button key={id} onClick={() => setAba(id)} style={{
      padding: "9px 16px", borderRadius: 9, border: aba === id ? 0 : "1px solid var(--border-color)",
      background: aba === id ? ORANGE : "transparent", color: aba === id ? "#fff" : "var(--text-secondary)",
      fontWeight: 700, fontSize: 13, cursor: "pointer", fontFamily: "inherit",
    }}>{rot}</button>
  );

  return (
    <div style={{ padding: 24, fontFamily: "'Inter',-apple-system,sans-serif", background: "var(--page-bg)", minHeight: "100vh" }}>
      <div style={{ marginBottom: 18 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--text-primary)" }}>Integrações</h1>
        <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)" }}>Ligue o WhatsApp da clínica e faça os contatos do site caírem direto no funil.</p>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
        {abaBtn("whatsapp", "WhatsApp oficial")}
        {abaBtn("site", "Contatos do site")}
      </div>

      {aba === "whatsapp" ? <WhatsappOficial /> : <LeadsDoSite />}
    </div>
  );
}
